import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const SystemParameters = ProtectedJsonAPI.extend(
  '/system_parameters',
  {
    update:  endpoint => endpoint.method('put').path(({name}) => name),
    show:    endpoint => endpoint.path(({name}) => name)
  }
)